import LiPrint from "./src/index.vue";

LiPrint.install = function (Vue) {
  Vue.component(LiPrint.name, LiPrint);
};

export default LiPrint;
